import { AnchorComponent, ButtonAnchor } from '..';

export const JoinDirections = ({ online_join_url, style }) => {
    if (!online_join_url) return null;

    return (
        <div style={{ marginBottom: '30px', ...style }}>
            <h2>Joining instructions</h2>
            <p>To join the session, please click the link below: </p>
            <AnchorComponent href={online_join_url}>{online_join_url}</AnchorComponent>
            <br></br>
            <ButtonAnchor style={{ marginTop: '10px' }} appearance="primary" href={online_join_url}>
                Join Now
            </ButtonAnchor>
        </div>
    );
};
